import React, { useState } from "react";
import BlueImage from "../../assets/images/blue.jpeg";
const ArrayVideo = [
  {
    id: 1,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/8a8MLCB870c",
    thumbnail: "https://i.ytimg.com/vi/8a8MLCB870c/mqdefault.jpg",
  },
  {
    id: 2,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/iHYVdcfASgg",
    thumbnail: "https://i.ytimg.com/vi/iHYVdcfASgg/mqdefault.jpg",
  },
  {
    id: 3,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/z4iR_kMvBoI",
    thumbnail: "https://i.ytimg.com/vi/z4iR_kMvBoI/mqdefault.jpg",
  },
  {
    id: 4,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/_jG3JjkHcbA",
    thumbnail: "https://i.ytimg.com/vi/_jG3JjkHcbA/mqdefault.jpg",
  },
  {
    id: 5,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/TtRbdiTZQDQ",
    thumbnail: "https://i.ytimg.com/vi/TtRbdiTZQDQ/mqdefault.jpg",
  },
  {
    id: 6,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/gRUP9wSayog",
    thumbnail: "https://i.ytimg.com/vi/gRUP9wSayog/mqdefault.jpg",
  },
  {
    id: 7,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/1UNVJIAPZ6o",
    thumbnail: "https://i.ytimg.com/vi/1UNVJIAPZ6o/mqdefault.jpg",
  },
  {
    id: 8,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/__5kKohD-OQ",
    thumbnail: "https://i.ytimg.com/vi/__5kKohD-OQ/mqdefault.jpg",
  },
  {
    id: 9,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/tqu4YQ9S_C4",
    thumbnail: "https://i.ytimg.com/vi/tqu4YQ9S_C4/mqdefault.jpg",
  },
  {
    id: 10,
    title: "المقدمة",
    link: "https://www.youtube.com/embed/sj1FTyZcZrM",
    thumbnail: "https://i.ytimg.com/vi/sj1FTyZcZrM/mqdefault.jpg",
  },
  {
    id: 11,
    title: "الندوة النسائيه للمرشح سعود العصفور لأنتخابات مجلس الامة ٢٠٢٣",
    link: "https://www.youtube.com/embed/yoSfmyoMEqI",
    thumbnail: "https://i.ytimg.com/vi/yoSfmyoMEqI/mqdefault.jpg",
  },
  {
    id: 12,
    title: "شنو اللي صار ",
    link: "https://www.youtube.com/embed/VBi3BtX1wqs",
    thumbnail: "https://i.ytimg.com/vi/VBi3BtX1wqs/mqdefault.jpg",
  },
];

function VideoHeader() {
  const [selectedVideo, setSelectedVideo] = useState(ArrayVideo[0]);
  return (
    <div className="container my-5 w-100 ">
      <iframe
        width="100%"
        height="500px"
        src={selectedVideo.link}
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        className="rounded-4"
      ></iframe>

      <div className="container w-100">
        <div className="row my-3">
          {ArrayVideo.map((item) => {
            return (
              <div
                className="col-6 col-sm-4 col-md-3 col-lg-3 my-2"
                onClick={() => {
                  setSelectedVideo(item);
                }}
              >
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  style={{ width: "95%", height: "100%", cursor: "pointer" }}
                  className="rounded-4 "
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default VideoHeader;
